import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { API_BASE, PROJECT_ID_PREFIX } from '../../constants';
import { getAuthToken } from '../../hooks/auth';

export const baseQuery = fetchBaseQuery({
  baseUrl: API_BASE,
  prepareHeaders: (headers) => {
    const token = getAuthToken();
    const projectId = window?.location?.pathname?.split('/')?.[2];
    const additionalHeaders: { [key: string]: string } = {};
    const featureSlot = sessionStorage.getItem('featureSlot');

    if (token !== null && token.length > 0) {
      additionalHeaders['Authorization'] = 'Bearer ' + token;
    }
    if (projectId?.includes(PROJECT_ID_PREFIX)) {
      additionalHeaders['ProjectId'] = projectId.replace(PROJECT_ID_PREFIX, '');
    }

    if (featureSlot && featureSlot !== 'Dev') {
      additionalHeaders['Feature'] = featureSlot;
    }

    Object.entries(additionalHeaders).map(([key, value]) => {
      headers.set(key, value);
    });
    return headers;
  },
});
